export default __webpack_public_path__ + "static/new-bee-4de8f50f1789fd74a104d53576438f26.png";